
import { List as ImmutableList } from 'immutable';
import { noNaN } from 'utils/utils';
import { getTxnStateInfo } from 'data/transactions/utils';
import { DateTime } from 'luxon';


export function calcRunningBalances(txns, sortBy, sortOrder, endingBalance) {

  if (sortBy !== 'date') {
    return txns;
  }

  let txnsWithBalances = [];

  let balance = endingBalance;

  const reverse = (sortOrder === 'ascending');
  const parseList = reverse ? txns.reverse() : txns;

  parseList.forEach((txn) => {
    const txnWithBalance = txn.set('balance', balance);
    txnsWithBalances.push(txnWithBalance);
    balance -= noNaN(txn.amount);
  });

  if (reverse) {
    txnsWithBalances = txnsWithBalances.reverse();
  }

  return new ImmutableList(txnsWithBalances);
}

export function filterFutureOrDueOverdue(txn) {
  const info = getTxnStateInfo(txn);
  if (info.status === 'DUE' || info.status === 'OVERDUE') {
    return true;
  }
  return DateTime.fromISO(txn.postedOn) > DateTime.local();
}

export function padBounds(balances) {
  const firstMin = Math.min(...balances) || 0;
  const firstMax = Math.max(...balances) || 100;
  const deviation = (firstMax - firstMin) || Math.abs(firstMax)/4 || 100;

  let minBalance = firstMin;
  let maxBalance = firstMax;

  if (minBalance > 0) {
    minBalance -= (minBalance * 0.4);
  } else {
    minBalance -= (deviation*0.2);
  }

  if (maxBalance > 0) {
    maxBalance += deviation*0.3;
  } else {
    maxBalance -= (maxBalance * 0.4);
  }

  const minLimit = firstMin - deviation;
  if (minBalance < minLimit) {
    minBalance = minLimit;
  }
  const maxLimit = firstMax + deviation;
  if (maxBalance > maxLimit) {
    maxBalance = maxLimit;
  }

  return {
    min: minBalance,
    max: maxBalance,
    high: firstMax,
    low: firstMin,
  };
}

